import axiosInstance from "./AxiosInstance";

export function getNoteCategories(
  pagination,
  pageid,
  search_by = "",
  search_keyword = "",
  sort_by = "",
  sort_order = ""
) {
  return axiosInstance.post("note-categories/list", {
    pagination,
    pageid,
    search_by,
    search_keyword,
    sort_by,
    sort_order,
  });
}

export function addNoteCategory(noteCategoryData) {
  return axiosInstance.post("note-categories/add", noteCategoryData);
}

export function updateNoteCategory(noteCategoryData) {
  return axiosInstance.post("note-categories/edit", {
    ...noteCategoryData,
  });
}

export function deleteNoteCategory(noteCategoryId) {
  return axiosInstance.post("/note-categories/delete", {
    category_id: noteCategoryId,
  });
}

export function formatNoteCategories(responseData) {
  if (!responseData) return [];

  return responseData.map((item) => ({
    id: item.category_id,
    name: item.category_text,
    colour: item.bg_color,
    forground_color: item.forground_color, // ✅ NEW
    sequence: item.sequence_no,
    is_active: item.category_status === "Active" ? 1 : 0,
    created_at: item.created_at,
    updated_at: item.updated_at,
  }));
}

